/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachLinkIcon16Solid = forwardRef('AttachLinkIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M0 8a5 5 0 0 1 5-5h1a1 1 0 0 1 0 2H5a3 3 0 0 0 0 6h1a1 1 0 1 1 0 2H5a5 5 0 0 1-5-5Z" }),
        React.createElement("path", { d: "M16 8a5 5 0 0 0-5-5h-1a1 1 0 0 0 0 2h1a3 3 0 1 1 0 6h-1a1 1 0 1 0 0 2h1a5 5 0 0 0 5-5Z" }),
        React.createElement("path", { d: "M5 7a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H5Z" })));
});
